var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('youtube',{ref:_vm.videoId,attrs:{"video-id":_vm.videoId}})}
var staticRenderFns = []

export { render, staticRenderFns }